/**
 * Format the submission time to a readable format
 * @param {string} isoString - The ISO string to format example: 2026-02-23T13:15:37.000Z
 * @returns {string} The formatted submission time example: 23 Feb 2026, 05:30 PM
 */

export default function getSubmissionTimeFormat(isoString) {
    return new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: 'Asia/Kolkata',
    }).format(new Date(isoString));
  };